import React, { useState } from "react";
import { Link2, Check, Share2 } from "lucide-react";
import { toast } from "sonner";
import SocialIcon from "./SocialIcon";
import { shareLinks } from "../lib/social";
import { useLang } from "../i18n";

const ShareButtons = ({ url, title, image, compact = false }) => {
  const { lang } = useLang();
  const [copied, setCopied] = useState(false);
  const links = shareLinks({ url, title, image });

  const copy = () => {
    navigator.clipboard.writeText(url);
    setCopied(true);
    setTimeout(() => setCopied(false), 1500);
    toast.success(lang === "fr" ? "Lien copié !" : "Link copied!");
  };

  return (
    <div data-testid="share-buttons" className="flex items-center gap-2 flex-wrap">
      {!compact && (
        <span className="flex items-center gap-1.5 text-xs uppercase tracking-widest text-foreground/50 mr-1">
          <Share2 className="w-3.5 h-3.5" /> {lang === "fr" ? "Partager" : "Share"}
        </span>
      )}
      {links.map((l) => (
        <a
          key={l.name}
          data-testid={`share-${l.name}`}
          href={l.url}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={l.label}
          className="w-9 h-9 flex items-center justify-center border border-border text-foreground/70 hover:bg-primary hover:text-primary-foreground hover:border-primary transition-colors"
        >
          <SocialIcon name={l.name} className="w-4 h-4" />
        </a>
      ))}
      <button
        data-testid="share-copy"
        onClick={copy}
        aria-label="Copy link"
        className="w-9 h-9 flex items-center justify-center border border-border text-foreground/70 hover:bg-primary hover:text-primary-foreground hover:border-primary transition-colors"
      >
        {copied ? <Check className="w-4 h-4" /> : <Link2 className="w-4 h-4" />}
      </button>
    </div>
  );
};

export default ShareButtons;
